module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(this.$store.state.modal.adicionarGlosa.show === true) ? _c('div', {
    staticClass: "in show modal fade adicionarGlosa",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    class: [(this.$store.state.modal.adicionarGlosa.status) ? 'sucesso' : 'falhou', 'modal-header']
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title alert-title"
  }, [_c('span', [_c('b-icon', {
    attrs: {
      "icon": "wallet2"
    }
  })], 1), _vm._v(" Evidência de glosa\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body content-body"
  }, [_c('form-adicionar-glosa', {
    attrs: {
      "contrato": this.$store.state.contrato,
      "fecharModal": _vm.fecharModal
    }
  })], 1)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32722ec8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/glosa/modal/ModalAdicionarEvidenciaGlosa.vue
// module id = 972
// module chunks = 1